import { GlobalStyles } from '@mui/material'

// ── Timing ────────────────────────────────────────────────────────────────────

/** How long an auto-dismiss toast stays visible before starting its exit. */
export const AUTO_DISMISS_DURATION = 5000
/** Duration of the slide-right exit animation (ms). */
export const DISMISS_ANIMATION_DURATION = 300
/** Duration of the height/margin collapse after the slide-out (ms). */
export const COLLAPSE_DURATION = 220
/** Per-item bottom margin (px) so it can be transitioned to 0 on collapse. */
export const ITEM_GAP = 8
/** Delay increment between successive toasts entering at the same time (ms). */
export const STAGGER_MS = 75

// ── Animation helpers ─────────────────────────────────────────────────────────

/** Returns the CSS `animation` shorthand for a toast entering the screen. */
export const slideInAnimation = (enterDelay: number) =>
  `toast-slide-in 300ms ease-out ${enterDelay}ms both`

/** CSS `animation` shorthand for a toast exiting the screen. */
export const slideOutAnimation = `toast-slide-out ${DISMISS_ANIMATION_DURATION}ms ease-in forwards`

/** CSS `animation` shorthand for the countdown bar inside an auto-dismiss toast. */
export const timerAnimation = `toast-timer ${AUTO_DISMISS_DURATION}ms linear forwards`

// ── Global keyframes ──────────────────────────────────────────────────────────

/**
 * All toast keyframes hoisted to a single GlobalStyles element so MUI injects
 * them once — not on every component render.
 */
export const ToastGlobalStyles = (
  <GlobalStyles
    styles={{
      '@keyframes toast-slide-in': {
        '0%': { transform: 'translateX(110%) translateY(12px)', opacity: 0 },
        '100%': { transform: 'translateX(0)    translateY(0)', opacity: 1 },
      },
      '@keyframes toast-slide-out': {
        '0%': { transform: 'translateX(0)', opacity: 1 },
        '100%': { transform: 'translateX(110%)', opacity: 0 },
      },
      '@keyframes toast-timer': {
        '0%': { transform: 'scaleX(1)' },
        '100%': { transform: 'scaleX(0)' },
      },
      '@keyframes chip-shake': {
        '0%, 100%': { transform: 'translateX(0)' },
        '20%': { transform: 'translateX(-4px)' },
        '40%': { transform: 'translateX(4px)' },
        '60%': { transform: 'translateX(-3px)' },
        '80%': { transform: 'translateX(3px)' },
      },
    }}
  />
)
